import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Modal } from 'react-bootstrap';
import { useSelector } from "react-redux";
import axios from 'axios';
import Swal from 'sweetalert2';
import PayUForm from '../../Utils/PayUForm';
import { toast } from 'react-toastify';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';

function WorldLink({ operatorCode }) {
  const currentUser = useSelector((state) => state.data);
  const [detail, setDetail] = useState(false);
  const [payuData, setPayuData] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const { Subscriber, package_id, wallet_type } = e.target;
    try {
      let sendData = {
        service: "worldLink",
        service_provider: operatorCode,
        msisdn: Subscriber.value,
        amount: package_id ? (package_id?.value).split("|")[1] : detail?.amount,
        plan: package_id && (package_id?.value).split("|")[0],
        ref_stan: detail.refStan,
        bill_number: detail.billNumber,
        session_id: detail.session_id,
        wallet_type: wallet_type?.value,
      };
      if (detail) {
        const response = await axios.post("/recharge/services/pay", sendData);
        const { status, message, hashData, rechage_response: rd } = response.data;
        if (status) {
          if (hashData) {
            const payuData = {
              hash: hashData.hash,
              txnid: hashData.txId,
              amount: hashData.amount,
              firstname: currentUser.name,
              email: currentUser.email,
            };
            setPayuData(payuData);
          }
          else {
            let rechrgeMessage = "<table align='center'><tr><td>Subscriber</td><td>" + rd.subscriber_number + "</td></tr><tr><td>Amount</td><td>" + rd.amount + "</td></tr><tr><td>Receipt</td><td>" + rd.reciept + "</td></tr><tr><td colspan='100%'>" + rd.message + "</td></tr></table>"
            Swal.fire({
              title: 'Recharge Successful!',
              html: rechrgeMessage,
              icon: 'success',
              //confirmButtonText: 'OK'
            });
            setDetail(false);
          }
        }
        else {
          toast(message);
        }
      }
      else {
        let sendData = {
          service_slug: "worldlink-v2",
          service_provider: operatorCode,
          username: Subscriber.value
        };
        const response = await axios.post("/recharge/services/query", sendData);
        const { status } = response.data;
        if (status) {
          setDetail(response.data);
        }
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  return (
    <>
      {
        payuData && (
          <PayUForm formData={payuData} autoSubmit={true} />
        )
      }
      <Form onSubmit={handleSubmit}>
        <div className="row">
          <>
            <div class="col-lg-12 col-md-12">
              <label>Worldlink User Name</label>
              <input type="text" class="form-control" name="Subscriber" required />
            </div>
            {
              detail && (
                <>
                  {
                    detail.amount != 0 && (
                      <div class="col-lg-4 col-md-4">
                        <label>Bill Amount</label>
                        <div>
                          <input type="text" class="form-control" value={detail.amount} />
                        </div>
                      </div>
                    )
                  }
                  {
                    detail.package_options && (detail.package_options).length > 0 && (
                      <div class="col-lg-4 col-md-4">
                        <label>Packages Options</label>
                        <select class="form-control" name="package_id" required>
                          <option value="">--Select--</option>
                          {
                            (detail.package_options).map((pack, index) => (
                              <option value={pack.packageId + "|" + pack.packageRate}>{pack.packageLabel}</option>
                            ))
                          }
                        </select>
                      </div>
                    )
                  }
                  {
                    detail.available_renew_options && (detail.available_renew_options).length > 0 && (
                      <div class="col-lg-4 col-md-4">
                        <label>Available Renew Options</label>
                        <select class="form-control" name="package_id" required>
                          <option value="">--Select--</option>
                          {
                            (detail.available_renew_options).map((pack, index) => (
                              <option value={pack.packageId + "|" + pack.packageRate}>{pack.packageLabel}</option>
                            ))
                          }
                        </select>
                      </div>
                    )
                  }
                  <div class="col-lg-4 col-md-4">
                    <label>Wallet Type</label>
                    <select class="form-control" name="wallet_type" required>
                      <option value="">--Select--</option>
                      <option value="wallet">Wallet</option>
                      <option value="remitance">Remitance</option>
                      <option value="payu">Online payment(Payu)</option>
                    </select>
                  </div>
                </>
              )
            }
            <div class="col-lg-12 col-md-12">
              <input type="submit" className="search-btn btn btn-primary" value={detail ? "Pay" : "Check Payment"} />
            </div>
          </>
        </div>
      </Form>
    </>
  );
}

export default WorldLink;
